import {Component, Input, OnInit} from '@angular/core';

interface dataItem {
  title: string;
  template: string;
}
@Component({
  selector: 'icc-collaps',
  templateUrl: './icc-collaps.component.html',
  styleUrls: ['./icc-collaps.component.less']
})
export class IccCollapsComponent implements OnInit {
  // @Input() list:Array<dataItem>;
  // selectedItem: dataItem;

  list = [{
    index: 1,
    title: '短信',
    content: '1'
  },{
    index: 2,
    title: '语音',
    content: '2'
  },{
    index: 3,
    title: '微信',
    content: '3'
  },{
    index: 4,
    title: '邮件',
    content: '4'
  }];
  selectedIndex: number = 1;
  constructor() { }

  ngOnInit() {
  }

  collapsClick(item) {
    if(item.index !== this.selectedIndex) {
      // 展开
      this.selectedIndex = item.index;
    } else {
      this.selectedIndex = -1;
    }
  }

}
